import odata from 'odata-client';
import {
    DELETE_PROJECT_ACTIVITY_ENTRIES_REQUEST,
    DELETE_PROJECT_ACTIVITY_ENTRIES_ERROR,
    DELETE_PROJECT_ACTIVITY_ENTRIES_SUCCESS,
    TOKEN_EXPIRED
} from '../../types';
import { getServiceUrl, getDefaultHeader } from '../../../utils';
import RESOURCES from '../../../api/resources';
import { showNotification } from '../../notification';

export const tokenExpired = () => ({
    type: TOKEN_EXPIRED
});

export const deleteProjectActivityEntriesRequest = () => ({
    type: DELETE_PROJECT_ACTIVITY_ENTRIES_REQUEST,
});

export const deleteProjectActivityEntriesError = errorOrResults => ({
    type: DELETE_PROJECT_ACTIVITY_ENTRIES_ERROR,
    error: errorOrResults.message,
});

export const deleteProjectActivityEntriesSuccess = payload => ({
    type: DELETE_PROJECT_ACTIVITY_ENTRIES_SUCCESS,
    payload,
});

export default (entityId) => async (dispatch, getState) => {
    dispatch(deleteProjectActivityEntriesRequest());

    const query = odata({service: getServiceUrl()}).resource(RESOURCES.ProjectActivityEntries, entityId);

    const errorOrResult = await query.delete({
        headers: {
          Authorization: `Bearer ${getState().user.token}`,
          ...getDefaultHeader()
        }
    })
        .then(resp => resp)
        .then(res => {
            const ok = res.statusCode <= 299 && res.statusCode >= 200;

            if (res.statusCode === 500) {
                const errorKey = "GENERAL_SERVER_ERROR";
                return new Error(errorKey);
            } else if (!ok) {
                console.log('delete project activity entry api error', res.toJSON());
                const body = JSON.parse(res.body);
                const { Error: { Message } } = body
                const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
                return new Error(errorKey);
            } else {
                return true;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            dispatch(showNotification("Request probably timed out.", "error"))
        })

    if (errorOrResult instanceof Error) {
        dispatch(deleteProjectActivityEntriesError(errorOrResult));
        if (errorOrResult.message.split(":")[0] === "401") {
            dispatch(tokenExpired());
            dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
        }
        console.log("CODE ERROR: ", errorOrResult.message);
        /*dispatch(showNotification(errorOrResult.message, "error"))*/
        return errorOrResult;
    } else {
        /*dispatch(showNotification("SUCCESSFUL_SAVE", "success"))*/
    }

    dispatch(deleteProjectActivityEntriesSuccess(errorOrResult));

    return errorOrResult;
};